import "select2";

import "./cart/_cart";
import "./minicart/_minicart";
import "./checkout/_checkout";
import "./webshop/_webshop";
import "./header/_header";
import "./my-account/_my-account";
import "./footer/_footer";
import "./general/_general";
